import { render } from "./Abteilungen.vue?vue&type=template&id=283ab391&scoped=true"
import script from "./Abteilungen.vue?vue&type=script&lang=ts"
export * from "./Abteilungen.vue?vue&type=script&lang=ts"

import "./Abteilungen.vue?vue&type=style&index=0&id=283ab391&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-283ab391"

export default script